import axios from 'axios';
import { IManager } from 'features/managers/types';
import { domain } from './constants';
import { ErrorResponse } from './types';

const apiClient = axios.create({
  baseURL: `${domain}/api/managers`,
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const managersAPI = {
  getManagers: async () => {
    try {
      const { data } = await apiClient.post<IManager[] | ErrorResponse>(
        '/fetch.php'
      );

      if ('errorType' in data) {
        const error = data;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  },
};
